import { render, staticRenderFns } from "./NewsEntry.vue?vue&type=template&id=28687cea&"
import script from "./NewsEntry.vue?vue&type=script&lang=js&"
export * from "./NewsEntry.vue?vue&type=script&lang=js&"
import style0 from "./NewsEntry.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports